import { css } from 'styled-components';
import { Colors } from '@prezi/dragon';

export const disabledCss = css`
    background-color: ${Colors.neutral50};
    border-color: ${Colors.neutral80};
    cursor: not-allowed;
`;

export const placeholderCss = css`
    color: ${Colors.neutral200};
`;

export const inputCss = css<{ invalid?: boolean }>`
    width: 100%;
    outline-style: none;
    padding: 0.5em 1em;
    border-radius: 0.25em;
    border: 1px solid;
    height: 2.2em;
    transition: border-color 0.2s, box-shadow 0.2s;

    ${({ invalid = false }) =>
        invalid
            ? `
        &:not(:disabled) {
            border-color: ${Colors.red300};
        }
        &:not(:disabled):hover {
            border-color: ${Colors.red400};
        }
        &:not(:disabled):focus {
            border-color: ${Colors.red400};
            box-shadow: 0 0 4px 0 ${Colors.red300};
        }
    `
            : `
        border-color: ${Colors.neutral100};
        &:hover {
            border-color: ${Colors.neutral200};
        }
        &:focus {
            border-color: ${Colors.blue500};
            box-shadow: 0 0 4px 0 ${Colors.blue300};
        }
    `}
    &:disabled, &:focus:disabled, &:hover:disabled {
        ${disabledCss}
    }
    &::placeholder {
        ${placeholderCss}
    }
`;
